export default class FormType {
  static JOB_ALERT = new FormType("job_alert");
  static SPONTANEOUS = new FormType("spontaneous");
  static REFERRAL = new FormType("referral");

  constructor(name) {
    this.name = name;
  }
}
